module.exports = __webpack_public_path__ + "static/media/iot.f37d905a.png";